"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Award, CircleCheck, Stethoscope } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function MeetDrAwaisAfridi() {
  const imageReveal = useRevealOnScroll({
    threshold: 0.2
  });
  const contentReveal = useRevealOnScroll({
    threshold: 0.2
  });
  const qualifications = [{
    text: "Prosthodontist",
    icon: <CircleCheck className="size-3 mr-1" />
  }, {
    text: "Restorative Expert",
    icon: <CircleCheck className="size-3 mr-1" />
  }, {
    text: "Specialist",
    icon: <CircleCheck className="size-3 mr-1" />
  }];
  return <section data-section-id="105296" id="meet-dr-tal-morr" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute top-0 left-0 w-full h-full overflow-hidden z-0">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" />
        <div className="absolute top-[60%] -right-[10%] w-[40%] h-[40%] rounded-full bg-secondary/5 blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={imageReveal.ref} className={`relative transition-all duration-1000 ease-out ${imageReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative rounded-[4px] overflow-hidden shadow-2xl border border-border/50 aspect-[4/5] lg:aspect-[3/4]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/dr_tal_morr_portrait.png" alt="Dr. Tal Morr, Board Certified Prosthodontist" className="w-full h-full object-cover object-center" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent" />
              {}
              <div className="absolute top-4 right-4 size-16 border-t-2 border-r-2 border-primary/60 opacity-80" />
            </div>

            {}
            <Card className="absolute -bottom-8 -right-4 lg:-right-12 w-64 bg-background/90 backdrop-blur-xl border-primary/20 shadow-xl rounded-[4px]">
              <CardContent className="p-6 flex items-center gap-4">
                <div className="bg-primary/20 p-3 rounded-full text-primary">
                  <Award className="size-8" />
                </div>
                <div>
                  <p className="text-3xl font-bold text-foreground font-serif">4.9<span className="text-xl text-primary"></span></p>
                  <p className="text-sm text-muted-foreground font-sans font-medium">Board Certified Expert</p>
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div ref={contentReveal.ref} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${contentReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="inline-flex items-center gap-2 text-foreground font-sans font-semibold tracking-widest uppercase text-sm mb-4">
              <Stethoscope className="size-4" />
              <span>WELCOME TO</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl lg:text-4xl font-bold font-serif text-primary leading-tight mb-6 uppercase">EL Prosthodontics</h2>

            <div className="flex flex-wrap gap-3 mb-8">
              {qualifications.map((qual, i) => <Badge key={i} data-index={i} variant={i === 0 ? "default" : "secondary"} className="px-4 py-1.5 text-xs font-sans rounded-[4px] shadow-sm uppercase tracking-wider">
                  {qual.icon}
                  {qual.text}
                </Badge>)}
            </div>

            <div className="space-y-6 text-sm text-foreground font-sans leading-[1.8] mb-10">
              <p>TMprosthodontics is the office of Dr Eric Leclercq . Dr. Leclercq is a prosthodontist, a specialist in the replacement and reconstruction of teeth. Dr. Leclercq is known for his advanced techniques, artistic abilities, and his perfectionism.</p>
              <p>
                With his vast knowledge of all aspects of dentistry, he can address most dental dilemmas. His approach combines elite medical precision with an artistic touch, ensuring every patient receives the highest level of care in a sophisticated and comforting environment.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-8 mt-4">
              <div className="flex flex-col gap-2">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/dr_tal_morr_signature.png" alt="Signature of Dr. Tal Morr" className="h-12 object-contain dark:invert opacity-90" />
                <span className="text-[10px] text-muted-foreground font-sans font-medium uppercase tracking-[0.2em]">
                  Founder & Lead Prosthodontist
                </span>
              </div>
              
              <div className="sm:ml-auto">
                <Button asChild size="lg" className="rounded-[4px] px-8 shadow-md hover:shadow-lg transition-all bg-foreground text-background hover:bg-primary hover:text-white">
                  <Link to="#">
                    EXPLORE MORE →
                  </Link>
                </Button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}